import "../assets/common9.css";
import { c as n } from "./index.bddf5ebb.js";
const l = "_buttonIcon_1e5o7_1", _ = "_black_1e5o7_39", a = "_ghost_1e5o7_48", e = "_small_1e5o7_56", o = {
  buttonIcon: l,
  black: _,
  ghost: a,
  small: e
}, r = ({
  className: c,
  size: t,
  variant: s
}) => n(o.buttonIcon, c, {
  [o[t]]: t !== "large",
  [o[s]]: s !== "default"
});
export {
  r as c
};
//# sourceMappingURL=common.4b17d1d1.js.map
